export default __webpack_public_path__ + "static/media/CareEvent-min.c7a0c6cf.png";